const apiKey = "AIzaSyB0XIn1TilBdvJcpfaBPAilXK1HLznLMaQ";

export const googleTranslate = require("google-translate")(apiKey);
